import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    standalone: false
})
export class AppMenuComponent implements OnInit {
    constructor(
        private permissoesService: PermissoesService,
      ) { }

    model: any[] = [];

    ngOnInit() {
        this.model = [
                {
                    items: [
                        {
                            label: 'Mapa de Ação',
                            icon: 'pi pi-fw pi-map',  
                            routerLink: ['/']
                        },
                        // {
                        //     label: 'Gráficos e leituras',
                        //     icon: 'pi pi-fw pi-home',  
                        //     routerLink: ['dashboard/null/null'],
                        //     visible: this.permissoesService.can('grafico_visualizar')
                        // },
                        // {
                        //     label: 'Resumo de eventos',
                        //     icon: 'pi pi-list',
                        //     routerLink: ['/resumo-eventos'],
                        //     visible: this.permissoesService.can('resumo_eventos_visualizar')
                        // },
                        // {
                        //     label: 'Gráficos e leituras',
                        //     icon: 'pi pi-fw pi-home',
                        //     items: [
                                
                        //     {
                        //         label: 'Gráfico',
                        //         icon: 'pi pi-chart-bar',
                        //         routerLink: ['dashboard'],
                        //         visible: this.permissoesService.can('grafico_visualizar')
                        //     },
                        //     {
                        //         label: 'Variáveis',
                        //         icon: 'pi pi-list',
                        //         routerLink: ['/cadastro/variavel'],
                        //         visible: this.permissoesService.can('variaveis_visualizar')
                        //     },
                        //     {
                        //         label: 'Resumo de eventos',
                        //         icon: 'pi pi-list',
                        //         routerLink: ['/resumo-eventos'],
                        //         visible: this.permissoesService.can('resumo_eventos_visualizar')
                        //     },
                        // ]},
                        {
                            label: 'Estações',
                            icon: 'pi pi-chart-bar',
                            items: [
                                {
                                    label: 'Leituras',
                                    icon: 'pi pi-fw pi-table',  
                                    routerLink: ['dashboard/null/tabela'],
                                    visible: this.permissoesService.can('estacoes_visualizar')
                                },
                                {
                                    label: 'Gráficos',
                                    icon: 'pi pi-fw pi-chart-bar',  
                                    routerLink: ['dashboard/null/grafico'],
                                    visible: this.permissoesService.can('estacoes_visualizar')
                                },
                                {
                                    label: 'Cadastros e Alterações',
                                    icon: 'pi pi-fw pi-cog',  
                                    routerLink: ['/controle/estacao'],
                                    visible: this.permissoesService.can('estacoes_cadastros_visualizar')
                                },
                                {
                                    label: 'Grupo de Estações',
                                    icon: 'pi pi-fw pi-sitemap',  
                                    routerLink: ['/controle/grupo-estacao'],
                                    visible: this.permissoesService.can('grupo_estacao_visualizar')
                                },
                            ]
                        },
                        {
                            label: 'Informações',
                            icon: 'pi pi-folder',
                            items: [
                                {
                                label: 'Equipamentos',
                                icon: 'pi pi-ellipsis-h',
                                routerLink: '',
                                visible: this.permissoesService.can('equipamentos_visualizar')
                                },
                                {
                                    label: 'Documentos',
                                    icon: 'pi pi-folder',
                                    routerLink: ['/cadastro/documento-repositorio'],
                                    visible: this.permissoesService.can('documentos_visualizar')
                                },
                                {
                                    label: 'Observações e Movimentações',
                                    icon: 'pi pi-comments',
                                    routerLink: ['/cadastro/observacao'],
                                    visible: this.permissoesService.can('observacoes_visualizar')
                                },
                            ]
                        },
                        {
                            label: 'Monitoramento',
                            icon: '',
                            items: [
                                {
                                    label: 'Relatório de eventos e Monitoramentos',
                                    icon: 'pi pi-list',
                                    routerLink: ['/monitoramento-estacoes/relatorio-eventos'],
                                    visible: this.permissoesService.can('monitoramento_visualizar')
                                },
                                {
                                    label: 'Grupos de Email',
                                    icon: 'pi pi-user-plus',
                                    routerLink: ['/acesso/grupo-email'],
                                    visible: this.permissoesService.can('grupo_email_visualizar')
                                },
                                {
                                    label: 'Monitoramento estações',
                                    icon: 'pi pi-chart-bar',
                                    routerLink: ['/monitoramento-estacoes'],
                                    visible: this.permissoesService.can('monitoramento_visualizar')
                                },
                                {
                                    label: 'Resumo Monitoramento',
                                    icon: 'pi pi-desktop',
                                    routerLink: ['/controle/monitoramento'],
                                    visible: this.permissoesService.can('monitoramento_visualizar')
                                },
                                {
                                    label: 'Resumo de Eventos',
                                    icon: 'pi pi-table',
                                    routerLink: ['/controle/resumo-eventos'],
                                    visible: this.permissoesService.can('monitoramento_visualizar')
                                },
                            ]
                        },
                        {
                        label: 'Cadastros',
                        icon: 'pi pi-plus',
                        items: [
                        {
                            label: 'Clientes',
                            icon: 'pi pi-users',
                            routerLink: ['/cadastro/cliente-list'],
                            visible: this.permissoesService.can('clientes_visualizar')
                        },
                        {
                            label: 'Coletores',
                            icon: 'pi pi-fw pi-server',
                            routerLink: ['/configuracao/coletor'],
                            visible: this.permissoesService.can('coletores_visualizar')
                        },
                        {
                            label: 'Integradores',
                            icon: 'pi pi-fw pi-share-alt',  
                            routerLink: ['/configuracao/integrador'],
                            visible: this.permissoesService.can('integradores_visualizar')
                        },
                        {
                            label: 'Descodificadores',
                            icon: 'pi pi-fw pi-code',
                            routerLink: ['/configuracao/descodificador'],
                            visible: this.permissoesService.can('descodificadores_visualizar')
                        },
                        {
                            label: 'Transmissores',
                            icon: 'pi pi-fw pi-wifi',
                            routerLink: ['/cadastro/sensor'],
                            visible: this.permissoesService.can('sensores_visualizar')
                        },
                        {
                            label: 'Sensores',
                            icon: 'pi pi-fw pi-circle',
                            routerLink: ['/cadastro/tipo-sensor'],
                            visible: this.permissoesService.can('sensores_visualizar')
                        },
                        {
                            label: 'Credenciais de API',
                            icon: 'pi pi-key',
                            routerLink: ['/cadastro/credencias-api'],
                            visible: this.permissoesService.can('credenciais_api_visualizar')
                        },
                        {
                            label: 'Dados de Variável',
                            icon: 'pi pi-database',
                            routerLink: ['/cadastro/dados-variavel'],
                            visible: this.permissoesService.can('dados_variavel_visualizar')
                        },
                        {
                            label: 'Importação Retrive',
                            icon: 'pi pi-upload',
                            routerLink: ['/cadastro/retrive-importacao'],
                            visible: this.permissoesService.can('importacao_retrive_visualizar')
                        },
                        {
                            label: 'Cadastro de Eventos',
                            icon: 'pi pi-calendar',
                            routerLink: ['/cadastro/cadastro-evento'],
                            visible: this.permissoesService.can('cadastro_eventos_visualizar')
                        },
                        // {
                        //     label: 'Fornecedores',
                        //     icon: 'pi pi-users',
                        //     routerLink: ['/cadastro/fornecedor-list'],
                        //     visible: this.permissoesService.can('fornecedores_visualizar')
                        // },
                        // {
                        //     label: 'Integradores',
                        //     icon: 'pi pi-users',
                        //     routerLink: ['/cadastro/integrador-list'],
                        //     visible: this.permissoesService.can('integradores_visualizar')
                        // },
                        // {
                        //     label: 'Tipos de descodificadores',
                        //     icon: 'pi pi-bell',
                        //     routerLink: ['/cadastro/tipo-descodificador'],
                        //     visible: this.permissoesService.can('descodificadores_visualizar')
                        // },
                        // {
                        //     label: 'Equipamentos',
                        //     icon: 'pi pi-ellipsis-h',
                        //     routerLink: '',
                        //     visible: this.permissoesService.can('equipamentos_visualizar')
                        // },
                        // {
                        //     label: 'Documentos',
                        //     icon: 'pi pi-folder',
                        //     routerLink: '',
                        //     visible: this.permissoesService.can('documentos_visualizar')
                        // },
                        // {
                        //     label: 'Observações',
                        //     icon: 'pi pi-comments',
                        //     routerLink: ['/cadastro/observacao'],
                        //     visible: this.permissoesService.can('observacoes_visualizar')
                        // },
                        // {
                        //     label: 'Eventos',
                        //     icon: 'pi pi-check-square',
                        //     routerLink: '',
                        //     visible: this.permissoesService.can('eventos_visualizar')
                        // },
                    ]
                    },
                    {
                        label: 'Controles',
                        icon: 'pi pi-wifi',
                        items: [
                            // {
                            //     label: 'Estações',
                            //     icon: 'pi pi-bars',
                            //     routerLink: ['/controle/estacao'],
                            //     visible: this.permissoesService.can('estacoes_visualizar')
                            // },
                            // {
                            //     label: 'Grupos de Estações',
                            //     icon: 'pi pi-bars',
                            //     routerLink: ['/controle/grupo-estacao'],
                            //     visible: this.permissoesService.can('estacoes_visualizar')
                            // },
                            // {
                            //     label: 'Monitoramento',
                            //     icon: 'pi pi-desktop',
                            //     routerLink: ['/controle/monitoramento'],
                            //     visible: this.permissoesService.can('monitoramento_visualizar')
                            // },
                            {
                                label: 'Log de Integradores',
                                icon: 'pi pi-list',
                                routerLink: ['/controle/log-execucao-integracao'],
                                visible: this.permissoesService.can('log_execucao_integracao_visualizar')
                            },
                            {
                                label: 'Log de Coletores',
                                icon: 'pi pi-list',
                                routerLink: ['/controle/log-execucao-coleta'],
                                visible: this.permissoesService.can('log_coletores_visualizar')
                            },
                            {
                                label: 'DashBoard Operação (*)',
                                icon: 'pi pi-chart-line',
                                routerLink: ['/controle/dashboard-operacao'],
                                visible: this.permissoesService.can('dashboard_operacao_visualizar')
                            },
                            {
                                label: 'Log de Backup',
                                icon: 'pi pi-database',
                                routerLink: ['/controle/log-backup'],
                                visible: this.permissoesService.can('log_backup_visualizar')
                            },
                            {
                                label: 'Log de ações de usuários',
                                icon: 'pi pi-history',
                                routerLink: ['/controle/log-usuario'],
                                visible: this.permissoesService.can('log_acoes_usuarios_visualizar')
                            },
                            {
                                label: 'Log Sistema',
                                icon: 'pi pi-file',
                                visible: this.permissoesService.can('log_execucao_integracao_visualizar')
                            },
                        ]
                    },
                    {
                        label: 'Configurações',
                        icon: 'pi pi-share-alt',
                        items: [
                            {
                                // label: 'Eventos dos Serviços',
                                label: 'Serviços do Sistema',
                                icon: 'pi pi-fw pi-cog',  
                                routerLink: ['/configuracao/evento-servico'],
                                visible: this.permissoesService.can('config_evento_servico_visualizar')
                            },
                            // {
                            //     label: 'Integradores',
                            //     icon: 'pi pi-fw pi-home',  
                            //     routerLink: ['/configuracao/integrador'],
                            //     visible: this.permissoesService.can('config_integradores_visualizar')
                            // },
                            // {
                            //     label: 'Coletores',
                            //     icon: 'pi pi-fw pi-home',
                            //     routerLink: ['/configuracao/coletor'],
                            //     visible: this.permissoesService.can('coletores_visualizar')
                            // },
                            // {
                            //     label: 'Descodificadores',
                            //     icon: 'pi pi-fw pi-home',
                            //     routerLink: ['/configuracao/descodificador'],
                            //     visible: this.permissoesService.can('descodificadores_visualizar')
                            // },
                            // {
                            //     label: 'Modelo de e-mail',
                            //     icon: 'pi pi-fw pi-home',
                            //     routerLink: ['/configuracao/modelo-email'],
                            //     visible: this.permissoesService.can('modelo_email_visualizar')
                            // },
                           
                        ]
                    },
                    {
                        label: 'Acessos',
                        icon: 'pi pi-key',
                        items: [
                            {
                                label: 'Usuários',
                                icon: 'pi pi-user-plus',
                                routerLink: ['/acesso/usuario'],
                                visible: this.permissoesService.can('cadastro_de_usuarios_visualizar')
                            },
                            {
                                label: 'Perfis de Usuários',
                                icon: 'pi pi-user-plus',
                                routerLink: ['/acesso/grupo-usuario'],
                                visible: this.permissoesService.can('grupos_do_usuario_visualizar')
                            },
                            {
                                // label: 'Direitos por Grupo',
                                label: 'Privilégios Perfis',
                                icon: 'pi pi-user-edit',
                                routerLink: ['acesso/direitos/usuario'],
                                visible: this.permissoesService.can('direito_grupo_visualizar')
                            },
                            // {
                            //     label: 'Grupos do Usuário',
                            //     icon: 'pi pi-user-plus',
                            //     routerLink: ['/acesso/grupo-usuario'],
                            //     visible: this.permissoesService.can('grupos_do_usuario_visualizar')
                            // },
                            // {
                            //     label: 'Grupos de Email',
                            //     icon: 'pi pi-user-plus',
                            //     routerLink: ['/acesso/grupo-email'],
                            //     visible: this.permissoesService.can('grupos_do_usuario_visualizar')
                            // },
                            // {
                            //     label: 'Acesso de clientes',
                            //     icon: 'pi pi-user',
                            //     routerLink: '',
                            //     visible: this.permissoesService.can('acesso_clientes_visualizar')
                            // },  
                        ]
                    },
                    {
                        label: 'Relatórios',
                        icon: 'pi pi-chart-line',
                        items: [
                            {
                                label: 'Relatórios do Sistema',
                                icon: 'pi pi-table',
                                routerLink: '',
                                visible: this.permissoesService.can('relatorios_sistema_visualizar')
                            },
                            {
                                label: 'Relatório de Desempenho',
                                icon: 'pi pi-table',
                                routerLink: ['/relatorios/desempenho'],
                                visible: this.permissoesService.can('relatorio_desempenho_visualizar')
                            },
                            // {
                            //     label: 'Analíticos dos dados coletados e integrados',
                            //     icon: 'pi pi-table',
                            //     routerLink: '',
                            //     visible: this.permissoesService.can('analiticos_coletados_integrados_visualizar')
                            // },
                            // {
                            //     label: 'Gráfico dos dados coletados e integrados',
                            //     icon: 'pi pi-table',
                            //     routerLink: '',
                            //     visible: this.permissoesService.can('grafico_coletados_integrados_visualizar')
                            // },
                            // {
                            //     label: 'Logs do sistema',
                            //     icon: 'pi pi-table',
                            //     routerLink: '',
                            //     visible: this.permissoesService.can('logs_visualizar')
                            // },
                        ]
                    },
                    ]
                
                },
               
            
        ];
        
        // Remove agrupadores sem sub-menus visíveis
        this.model = this.model.map(menuItem => {
            if (menuItem.items && Array.isArray(menuItem.items)) {
                return {
                    ...menuItem,
                    items: this.filtrarAgrupadoresVazios(menuItem.items)
                };
            }
            return menuItem;
        });
    }

    /**
     * Remove menus agrupadores que não possuem sub-menus visíveis
     * Um agrupador é identificado por ter items e não ter routerLink (ou routerLink vazio)
     */
    filtrarAgrupadoresVazios(menus: any[]): any[] {
        return menus
            .map(menu => {
                // Se o menu tem items (é um agrupador)
                if (menu.items && Array.isArray(menu.items)) {
                    // Filtra os sub-menus visíveis (recursivamente)
                    const subMenusVisiveis = this.filtrarAgrupadoresVazios(
                        menu.items.filter(item => item.visible !== false)
                    );
                    
                    // Verifica se é um agrupador (tem items mas não tem routerLink válido)
                    const isAgrupador = !menu.routerLink || 
                                       (Array.isArray(menu.routerLink) && menu.routerLink.length === 0) ||
                                       menu.routerLink === '';
                    
                    // Se é agrupador e não tem sub-menus visíveis, remove o agrupador
                    if (isAgrupador && subMenusVisiveis.length === 0) {
                        return null; // Marca para remoção
                    }
                    
                    // Atualiza os items com os sub-menus filtrados
                    return {
                        ...menu,
                        items: subMenusVisiveis
                    };
                }
                
                // Se não é agrupador, mantém como está
                return menu;
            })
            .filter(menu => menu !== null); // Remove os agrupadores marcados para remoção
    }
}
